import '../../css/content.css';
import React from 'react';
import Tooltip from '../Tooltip';

import xray from '../../img/x-ray-icons-teal-glow.png'
import chatbubble from '../../img/group-2841.svg'

const Content2 = () => {

  return(
    <>
       {/* 1 */}
       <div id="partial-0" className="partial-container partial-container-8 flex mobile:!justify-center">
       <div className="min-h-fit">
        <h3>Testing lung function</h3>
        <p>When you have <span className="whitespace-nowrap"><Tooltip>MAC lung disease</Tooltip>,</span> a common method that your doctor may use to evaluate your lung function is a <Tooltip>spirometry</Tooltip> test.</p>
        <img src={xray} alt="xray" className="mx-auto mb-[-30px] lg:mb-[-50px]" />
        </div>
      </div>

      {/* 2 */}
      <div id="partial-1" className="partial-container partial-container-9 mobile:mt-0 mobile:pt-0 mb-8">
        <p>This test tells a doctor how strong your lungs are by measuring the amount of air you can exhale. Anything 80% or better is considered within normal range.</p>
      </div>

      {/* 3 */}
      <div id="partial-2" className="partial-container partial-container-10 flex !justify-center flex-col">
      <div className="min-h-fit flex flex-col justify-center align-middle items-center">
        <p className="mt-12">If your breathing has gotten worse, <span className="text-watermelon">talk to your doctor</span> and find out if you should have a <Tooltip>spirometry</Tooltip> test done.</p>
        <img src={chatbubble} alt="chatbubble" />
      </div>
      </div>
    </>
  )
};

export default Content2;